import styled from 'styled-components';

export const Container = styled.div`
    height: 75px;
    width: 100%;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.1);
`;

export const LogoLink = styled.a`
    display: flex;
    align-items: center;
    gap: 14px;
    text-decoration: none;
`;

export const AppIcon = styled.img`
    height: 48px;
    width: 48px;
    border-radius: 12px;
    object-fit: cover;
`;

export const AppName = styled.span`
    font-size: 26px;
    font-weight: 700;
    color: #fff;
    letter-spacing: -0.5px;
`;
